import React, {useRef, useEffect, useCallback} from 'react';
import PlayIcon from './assets/playIcon.png';
import {useIntersection} from '../../../../hooks/useIntersectionObserver';
import {MAX_RETRY_LIMIT} from '../../../../constants';

const MyVideo = ({isMobile, setActiveItem, activeItem, index, videoSource, sliderRef}) => {
  const videoRef = useRef(null);
  const videoRetryRef = useRef(0);

  const onIntersection = useCallback((isElemIntersecting, obs, entry) => {
    if (isElemIntersecting) {
      videoRef.current = entry.target;
      const [videoSourceElement] = entry.target.children;
      entry.target.src = videoSourceElement.dataset.src;
      entry.target.load();
      return false;
    }
  }, []);

  const [, interSectionElem] = useIntersection(onIntersection);

  const playPauseVideo = useCallback(() => {
    sliderRef.current.slickGoTo(index);
    if (activeItem !== index) {
      videoRef.current.play();
      setActiveItem(index);
      return;
    }
    videoRef.current.pause();
    setActiveItem(null);
  }, [activeItem, index, setActiveItem, sliderRef]);

  useEffect(() => {
    if (index !== activeItem) {
      videoRef?.current?.pause();
    }
  }, [activeItem, index]);

  const handleReload = useCallback(() => {
    if (videoRef.current?.load && videoRetryRef.current < MAX_RETRY_LIMIT) {
      videoRetryRef.current++;
      videoRef.current.load?.();
    }
  }, []);

  return (
    <>
      <video
        ref={interSectionElem}
        onError={handleReload}
        width="100%"
        height="100%"
        onClick={playPauseVideo}
        preload="metadata"
        loading="lazy"
      >
        <source data-src={videoSource} type="video/mp4" />
        Your browser does not support the html video tag.
      </video>
      {index !== activeItem && (
        <div className="imageWrapper" onClick={playPauseVideo}>
          <img
            src={PlayIcon}
            className={`playIcon ${isMobile ? 'mobilePlayIcon' : ''}`}
            alt="Play"
          />
        </div>
      )}
    </>
  );
};

export default MyVideo;
